import { getPostbackUrl } from '../../Signage/urlOverrides';

/**
 * Post a message back to CMS window if we've been iframed in from CMS.
 *
 * This tells CMS to show our window and hide the "loading" spinner.
 */
export function sendLoadedPostbackToCms(): void {
    //post a message back to CMS window if we've been iframed in from CMS
    //this tells CMS to show our window and hide the "loading" spinner
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if ((parent !== window.self) !== window.top) {
            const postbackUrl = getPostbackUrl();
            if (postbackUrl !== null) {
                parent.postMessage(
                    JSON.stringify({
                        status: 'OK',
                        message: 'LOAD_COMPLETE',
                    }),
                    postbackUrl
                );
            }
        }
    } catch (e) {
        // The original developer failed to document what exception they
        // were trying to catch, so it is unknown why this try/catch block
        // is here.
    }
}
